import { render } from "./PBackAlley.vue?vue&type=template&id=3f4471a2&scoped=true"
import script from "./PBackAlley.vue?vue&type=script&lang=js"
export * from "./PBackAlley.vue?vue&type=script&lang=js"

import "./PBackAlley.vue?vue&type=style&index=0&id=3f4471a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4471a2"]])

export default __exports__